<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                        <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                         &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("cml_billing_create") }}</h6>
                        <button
                          class="btn btn-default btn-sm float-end"
                          @click="resetForm"
                          type="button"
                        >
                        <i class="link-icon" data-feather="repeat"></i>
                          {{ $t("resetFormTxt") }}
                        </button>
                  </div>
                  <div class="card-body">
                    <form
                      class="forms-sample"
                      @submit.prevent="submitData"
                      method="POST"
                    >
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="customerId" class="col-form-label" style="padding-left: 25px">{{
                            $t('customerId')
                          }}</label>
                        </div>
                        <div class="col-lg">
                          
                          <v-select
                              :options="fetchCustomer"
                              v-model="customer"
                              label="customerId"
                              return-object
                              @search="asyncSearchCustomer"
                            >
                            <template slot="option" slot-scope="option">
                                {{ option.customerId }} - {{option.customerName}}
                            </template>
                        </v-select>
  
  
  
                          <div v-if="errors.customerId">
                            <div
                              v-for="error in errors.customerId"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="warehouseId" class="col-form-label" style="padding-left: 25px">{{
                            $t('warehouseId_txt')
                          }}</label>
                        </div>
                        <div class="col-lg">
                          
                          <v-select
                              :options="fetchFulfillment"
                              v-model="fulfillment"
                              label="warehouseId"
                              return-object
                              @search="asyncSearchFulfillment"
                            >
                            <template slot="option" slot-scope="option">
                                {{ option.warehouseId }} - {{option.WarehouseDescr}}
                            </template>
                            
                          </v-select>
  
  
  
                          <div v-if="errors.warehouseId">
                            <div
                              v-for="error in errors.warehouseId"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="idRateHeader" class="col-form-label" style="padding-left: 25px">{{
                            $t('idRate')
                          }}</label>
                        </div>
                        <div class="col-lg">
                          
                          <v-select
                              :options="fetchRates"
                              v-model="rate"
                              label="rateName"
                              return-object
                              @search="asyncSearchRates"
                            >
                            <template slot="option" slot-scope="option">
                                {{ option.customerId }} - {{option.warehouseId}} - {{option.rateName}}
                            </template>
                            
                          </v-select>
  
  
  
                          <div v-if="errors.idRateHeader">
                            <div
                              v-for="error in errors.idRateHeader"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="tarifMasterId" class="col-form-label" style="padding-left: 25px">{{
                            $t('tariffMasterId')
                          }}</label>
                        </div>
                        <div class="col-lg">
                          <input
                            type="text"
                            class="form-control"
                            id="tarifMasterId"
                            :placeholder="$t('tariffMasterId')"
                            v-model="forms.tarifMasterId"
                            required
                          />
                          <div v-if="errors.tarifMasterId">
                            <div
                              v-for="error in errors.tarifMasterId"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('effectiveDate_txt')
                          }}</label>
                        </div>
                        <div class="col-lg">
  
                          <date-range-picker style="width:100%" @update="fromDatesChange" control-container-class="form-control" :locale-data="locale" v-model="fromDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false"></date-range-picker>
  
                          <div v-if="errors.effectiveFromDate">
                            <div
                              v-for="error in errors.effectiveFromDate"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
  
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('amount_txt')
                          }}</label>
                        </div>
                        <div class="col-lg">
  
                            <money class="form-control" v-model="forms.amount" v-bind="money"></money>
  
                          <div v-if="errors.amount">
                            <div
                              v-for="error in errors.amount"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
  
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="status" class="col-form-label" style="padding-left: 25px">{{
                            $t('multi_warehouse_flag')
                          }}</label>
                        </div>
                        <div class="col-lg">
                          
                          <v-select
                              :options="fetchmultiWhFlag"
                              v-model="forms.multiWhFlag"
                              return-object
                            ></v-select>
                          <div v-if="errors.multiWhFlag">
                            <div
                              v-for="error in errors.multiWhFlag"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="dataAdditionalStorageWmsFlag" class="col-form-label" style="padding-left: 25px">{{
                            $t('uploadDataAdditionalStorageWms')
                          }}</label>
                        </div>
                        <div class="col-lg">
                          
                          <v-select
                              :options="fetchYesOrNo"
                              v-model="forms.dataAdditionalStorageWmsFlag"
                              return-object
                            ></v-select>
                          <div v-if="errors.dataAdditionalStorageWmsFlag">
                            <div
                              v-for="error in errors.dataAdditionalStorageWmsFlag"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-3">
                          <label for="status" class="col-form-label" style="padding-left: 25px">{{
                            $t('statusTxt')
                          }}</label>
                        </div>
                        <div class="col-lg">
                          
                          <v-select
                              :options="fetchStatus"
                              v-model="forms.status"
                              return-object
                            ></v-select>
                          <div v-if="errors.status">
                            <div
                              v-for="error in errors.status"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button class="btn btn-primary float-end btn-sm" type="submit">
                             <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div> <!--end::card-->
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
    name        : "CmlBillingHeaderCreate",
    props       : {},
    components  : {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        DateRangePicker,
    },
    data() {

        const startDate = new Date();
        const endDate   = new Date();
        endDate.setDate(endDate.getDate() + 24);

        return {
        opens   :"center",
        locale  :{
            format:"yyyy-mm-dd",
        
        },
        fromDates   : {
            startDate   : startDate,
            endDate     : endDate
        },
        endDates    : {
            startDate   : startDate,
            endDate     : endDate
        },
        highlighted :{

            dates   : [ // Highlight an array of dates
                new Date(),
            ],

        },
        money   : {
            decimal     : ',',
            thousands   : '.',
            prefix      : '',
            suffix      : '',
            precision   : 2,
            masked      : false
        },
        disabledAfter   : new Date(2019, 10, 6),
        permision_role  : [],
        isLoading       : false,
        maxToasts       : 100,
        position        : "up right",
        closeBtn        : true,
        errors          : [],
        fetchStatus     : ['DRAFT'],
        fetchmultiWhFlag: ['Y','N'],
        fetchYesOrNo    : ['Y','N'],
        fetchCustomer   : [],
        fetchFulfillment: [],
        fetchRates      : [],
        company_group   : "",
        customer        : "",
        fulfillment     : "",
        rate            : "",
        userData        : "",
        userRole        : "",
        companyCode     : "",
        bm_rate_header  : {},
        forms           : {dataAdditionalStorageWmsFlag: "N", idBillingHeader: "",  tariffId:"",  customerId:"", warehouseId:"", transactionToDate:"", transactionFromDate:"",  status:"DRAFT" , amount:0, idRateHeader:"",  addwho:"",  editwho:"", adddate:"",  editdate:"" , multiWhFlag:"N"},
        };
    },
    watch   : {},
    methods : 
        {

            fromDatesChange(){

                if(this.fromDates.startDate && this.fromDates.endDate){
                    this.forms.transactionFromDate=this.$moment(String(this.fromDates.startDate)).format('YYYY-MM-DD');
                    this.forms.transactionToDate=this.$moment(String(this.fromDates.endDate)).format('YYYY-MM-DD');
                }
            
            },
            
            dateFormat (classes, date) {
                if (!classes.disabled) {
                    classes.disabled = date.getTime() < new Date();
                }
                return classes;
            },

            asyncSearchFulfillment(){


            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/warehouse/get-data?download=all";
            
            return this.$http
                .get(
                baseURI,{ timeout: 60000 }
                )
                .then((response) => {
                    this.fetchFulfillment=response.data.datas;
                }).catch(error => {

                if(error.code == "ECONNABORTED"){
                    this.error("Please Check Your Internet Connection");
                }

                });
            },

            asyncSearchCustomer(){

            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/customer/get-data?download=all";
            
            return this.$http
                .get(
                baseURI,{ timeout: 60000 }
                )
                .then((response) => {
                    this.fetchCustomer=response.data.datas;
                }).catch(error => {

                if(error.code == "ECONNABORTED"){
                    this.error("Please Check Your Internet Connection");
                }

                });
            },

            asyncSearchRates(){
                
                var customerId  = ""
                var warehouseId = ""

                if(typeof this.customer == "object"){
                    customerId = this.customer.customerId
                }
                    
                if(typeof this.fulfillment == "object"){
                    warehouseId = this.fulfillment.warehouseId
                }
                
                if(customerId !== "" & warehouseId !== ""){
                    const baseURI = this.$settings.endPointBilling + `dashboard/cml-billing/rate/header/get-data?customerId=${customerId}&warehouseId=${warehouseId}&download=all`;

                    return this.$http
                        .get(
                        baseURI,{ timeout: 60000 }
                        )
                        .then((response) => {
                            this.fetchRates=response.data.datas;
                        }).catch(error => {

                        if(error.code == "ECONNABORTED"){
                            this.error("Please Check Your Internet Connection");
                        }

                        });
                }else{
                    this.error(this.$t("pleaseSelectCompanyAndWarehouse"));
                }

                
            },

            resetForm() {

                this.forms.idBillingHeader      = "";
                this.forms.tariffId             = "";
                this.forms.warehouseId          = "";
                this.forms.customerId           = "";
                this.forms.transactionToDate    = "";
                this.forms.transactionFromDate  = "";
                this.forms.status               = "DRAFT";
                this.forms.multiWhFlag          = "N"
                this.forms.amount               = 0;
                this.forms.idRateHeader         = "";
                this.forms.addwho               = "";
                this.forms.editwho              = "";

            },

            fetchIt() {
                const userDatas     = this.$getUserInfo();
                this.userData       = userDatas.sub;
                this.userRole       = userDatas.sub.role;
                // this.permision_role = userDatas.sub.permision_role;
                let rolePermision = [];
                userDatas.sub.permision_role.forEach(function(permision){
                    if(permision.permission.controller == 'BillingCmlController'){
                    rolePermision = permision;
                    }
                });

                if(!rolePermision.method_create){
                    this.$router.push("/authorized-error");
                }
                this.permision_role = rolePermision;

            },

            backForm() {
                window.location.href = "/billing-cml/billing/header";
            },

            submitData() {
                this.isLoading = true;
                
                if(typeof this.customer == "object"){
                    this.forms.customerId = this.customer.customerId
                }else{
                    this.forms.customerId = ""
                }
                    
                if(typeof this.fulfillment == "object"){
                    this.forms.warehouseId = this.fulfillment.warehouseId
                }else{
                    this.forms.warehouseId = ""
                }
                    
                if(typeof this.rate == "object"){
                    this.forms.idRateHeader = this.rate.idRateHeader
                }else{
                    this.forms.idRateHeader = ""
                }
            
                const baseURI  =  this.$settings.endPointBilling+"dashboard/cml-billing/billing/create";
                this.$http.post(baseURI,this.forms,{ timeout: 60000 }).then((response) => {
                    this.loading();
                    if(response.data.status === 200) {
                    //this.resetForm();
                        this.isLoading = false;
                        this.errors = [];
                        //console.log(response.data.datas.user_id);
                        var params = this.$onRandom(response.data.datas.idBillingHeader);
                            window.location.href = "/billing-cml/billing/header/detail/" + params + "?status=200&msg=Successfully";
                        // this.success('Berhasil');
                    }else{
                        this.isLoading = false;
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                        this.loading();
                        this.isLoading = false;
                    
                if(error.code == "ECONNABORTED"){
                    this.error(this.$t("check_internet_connection_txt"));
                    
                }else{

                    if (error.response) {
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        }else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        }else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        }else{
                            this.$router.push('/page-not-found');
                        }
                    }

                }
                    //this.resetForm();
                });
                
            },

            logout(){

                const baseURI = this.$settings.endPoint + "user/logout";
                this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
                    
                console.log(response);

                });

                this.$logoutUser();
                window.location.href = '/';
            },

            fade(sType) {
                this.isLoading = sType;
            },

            loading() {
                this.fade(true);
                setTimeout(() => {
                    this.fade(false);
                }, 1000); // hide the message after 3 seconds
            },

            resultError(data) {
                var count = Object.keys(data).length;
                for (var x = 0; x < count; x++) {
                    var nameOb = Object.keys(data)[x];
                    var objectData = data[nameOb];
                    for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                    }
                }
            },

            success(kata) {
                const Toast = this.$swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                    },
                });
                Toast.fire({
                    icon: "success",
                    title: kata,
                });
            },

            error(kata) {
                const Toast = this.$swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
            },

        },

    events  : {},
    created : function () {},
    mounted() 
        {
            this.fetchIt();
        },
};

</script>

<style scoped>

</style>